/// all api for approve setting page
import API from "../api";
import * as URLS from "../constants/api";

async function getWorkFollow(id) {
  try {
    const response = await API.get(URLS.API_INSPECTION_WORKFLOW + "/" + id);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function getPaginatedWorkFollows(page, perPage, filters = {}) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    const data = {
      page: page,
      per_page: perPage,
      ...filters,
    };
    const response = await API.get(
      URLS.API_INSPECTION_WORKFLOW,
      { params: data },
      {
        headers,
      }
    );
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function submitWorkFlow(data, id) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
    };
    let response;
    let url = URLS.API_INSPECTION_WORKFLOW;
    if (/^\d+$/.test(id)) {
      url = url + `/${id}`;
    }
    // response = API(config);
    response = await API.post(url, JSON.stringify(data), { headers: headers });
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function deleteWorkFollows(ids) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    if (ids) {
      let response = await API.delete(URLS.API_INSPECTION_WORKFLOW, {
        headers: headers,
        data: {
          ids: ids,
        },
      });
      return response.data;
    }
  } catch (e) {
    throw e;
  }
}

const ApprovalSettingsServices = {
  submitWorkFlow,
  getWorkFollow,
  getPaginatedWorkFollows,
  deleteWorkFollows,
};

export {
  ApprovalSettingsServices as default,
  submitWorkFlow,
  getWorkFollow,
  getPaginatedWorkFollows,
  deleteWorkFollows,
};
